/**
 * Countries-related Redux Actions
 */
/* tslint:disable:max-line-length */
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('Countries');

// Request Async Actions
export const requestFetchCountries = actionCreator<IPromiseActionPayload<ICountryActionPayload>>('REQUEST_FETCH_COUNTRIES');
export const requestFetchStatesForCountry = actionCreator<IRequestFetchStatesForCountryActionPayload>('REQUEST_FETCH_STATES_FOR_COUNTRY');

// Async Actions
export const fetchCountries = actionCreator.async<any, ICountryActionPayload>('FETCH_COUNTRIES');
export const fetchStatesForCountry = actionCreator.async<ICountry, ICountryStateActionPayload>('FETCH_STATES_FOR_COUNTRY');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/countries.ts